{
  "meni": {
    "title": "Menu"
  },
  "uporabnik": {
    "odjava": "disconnessione"
  },
  "pregled": {
    "title": "Ispezione delle Superfici",
    "description": "Rapporto sull’ispezione delle superfici per il movimento degli aeromobili"
  },
  "dnevniRazpored": {
    "title": "Programma di Volo Giornaliero",
    "description": "Aggiungi / leggi il programma di volo giornaliero"
  },
  "startnaListaJ": {
    "title": "Lista di Partenza (Alianti)",
    "description": "Aggiungi una voce per un aliante"
  },
  "startnaListaM": {
    "title": "Lista di Partenza (Aerei a Motore)",
    "description": "Aggiungi una voce per un aereo a motore"
  },
  "startnaListaUL": {
    "title": "Lista dei partecipanti (UltraLight)",
    "description": "Aggiungi una scheda per un aereo ultraleggero"
  },
  "obracuni": {
    "title": "Calcoli",
    "description": "Panoramica dei registri"
  },
  "porocila": {
      "title": "Report e statistiche",
        "description": "Panoramica di voli, ore e attività"
  },
  "log": {
    "title": "Registro di Cancellazioni / Modifiche",
    "description": "Panoramica dei registri cancellati e modificati"
  },
  "dnevnikPilotov": {
    "title": "Diario dei Piloti",
    "description": "Inserimento e revisione del diario personale"
  },
  "dnevnikPilotovJ": {
    "title": "Diario di navigazione",
    "description": "Libretto personale del pilota per il volo a vela"
  },
  "nalogLet": {
    "title": "Ordine di Volo",
    "description": "Crea e invia un ordine di volo"
  },
  "dokumentacijaNalogov": {
    "title": "Documentazione degli Ordini",
    "description": "Approva / Rifiuta un ordine di volo"
  },
  "sifrantiP": {
    "title": "Piloti",
    "description": "Registro dei piloti"
  },
  "sifrantiL": {
    "title": "Aerei",
    "description": "Aggiungi il registro degli aerei"
  },
  "sifrantiK": {
    "title": "Club",
    "description": "Registro dei club"
  },
  "nastavitveLeta": {
    "title": "Impostazioni di Volo",
    "description": "Circuiti di addestramento, impostazioni delle condizioni attuali, ..."
  },
  "nastavitveIzpisov": {
    "title": "Impostazioni di Stampa",
    "description": "Impostazioni del timbro, logo, intestazione per le stampe, ..."
  },
  "nastavitve": {
    "title": "Impostazioni",
    "description": "Impostazioni del programma"
  },
  "pregledDostopov": {
    "title": "Panoramica degli Accessi",
    "description": "Panoramica degli accessi all’applicazione"
  },
  "patchNotes": {
    "title": "Note di Rilascio",
    "description": "Aggiungi / Sostituisci le patch notes"
  },
  "praviceUporabnikov": {
    "title": "Impostazioni dei Permessi",
    "description": "Impostazione dei permessi utente (modifica, eliminazione)"
  },
  "deaktivacijaUporabnikov": {
    "title": "Utenti disattivati",
    "description": "Gestione degli account disattivati"
  },
  "hr": {
    "dnevniki": "Diari",
    "dokumenti": "Documenti",
    "sifranti": "Registri",
    "nastavitveLeta": "Impostazioni di volo / stampa",
    "administracija": "Amministrazione",
    "pravice": "Permessi utente",
    "upravitelj": "Impostazioni di amministrazione",
    "briefing": "Briefing"
  },
  "availability": {
      "title": "Disponibilità",
      "description": "Comunicazione della disponibilità" 
  },
  "camo": {
    "title": "Camo",
    "description": "Manutenzione Camo"
  },
  "camo_log": {
    "title": "Camo Logs",
    "description": "Manutenzione Camo logs"
  },
  "upravitelj": {
    "title": "Upravitelj - nastavitve",
    "description": "Impostazioni amministratore. Nome amministratore, camo, impostazioni dei controlli,..."
  },
  "wb": {
    "title": "Peso e Bilanciamento",
    "description": "Calcolo del peso e del bilanciamento"
  }
}